import _isNumber from 'lodash/isNumber'

import { urlBase64ToUint8Array } from '@/lib/string/base64'

export function isVapidKeyMatching(sub: PushSubscription, vapidPublicKey: string): boolean {
  try {
    const subKey = sub.options?.applicationServerKey
    if (!subKey) {
      return false
    }
    const subBytes = new Uint8Array(subKey as ArrayBuffer)
    const currentBytes = urlBase64ToUint8Array(vapidPublicKey)
    if (subBytes.length !== currentBytes.length) {
      return false
    }
    return subBytes.every((byte, i) => byte === currentBytes[i])
  } catch {
    return false
  }
}

export function isSubscriptionValid(
  sub: PushSubscription | null,
  skewWindow = 5 * 60 * 1000
): boolean {
  // Validate subscription object exists
  if (!sub) {
    return false
  }

  // Validate expiration time (must not be expired or within skew window)
  const exp = sub.expirationTime
  if (_isNumber(exp) && Date.now() > exp - skewWindow) {
    return false
  }

  // Validate endpoint is present
  if (!sub.endpoint) {
    return false
  }

  try {
    const p256dh = sub.getKey('p256dh')
    const auth = sub.getKey('auth')
    if (!p256dh || p256dh.byteLength === 0 || !auth || auth.byteLength === 0) {
      return false
    }
  } catch {
    return false
  }

  return true
}
